/**
 * London Smoke & Cure — resolve first/last name for OrderDesk customer + shipping blocks.
 * Shared by customer cart submit and Admin "Place order on behalf".
 */

/**
 * Prefer explicit firstName/lastName; otherwise split fullName (first token / remainder).
 * @param {{ firstName?: string, lastName?: string, fullName?: string }|null|undefined} userData
 * @param {{ fallbackUnknown?: boolean }} [opts] — cart uses Unknown placeholders; admin can leave blank
 * @returns {{ first: string, last: string }}
 */
export function getOrderPersonNameFromUserProfile(userData, opts = {}) {
    const fallbackUnknown = opts.fallbackUnknown === true;
    const unknown = fallbackUnknown ? 'Unknown' : '';
    if (!userData || typeof userData !== 'object') {
        return { first: unknown, last: unknown };
    }

    const firstName = String(userData.firstName || '').trim();
    const lastName = String(userData.lastName || '').trim();
    if (firstName && lastName) {
        return { first: firstName, last: lastName };
    }

    const fullName = String(userData.fullName || '').trim();
    if (fullName) {
        const parts = fullName.split(/\s+/).filter(Boolean);
        return {
            first: parts[0] || unknown,
            last: parts.slice(1).join(' ') || (fallbackUnknown ? 'Unknown' : ''),
        };
    }

    if (firstName) return { first: firstName, last: lastName || (fallbackUnknown ? 'Unknown' : '') };
    if (lastName) return { first: fallbackUnknown ? 'Unknown' : '', last: lastName };

    return { first: unknown, last: unknown };
}
